/** @jsx jsx */
import { jsx } from '@emotion/react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/enterprise-admin-learners';

const { HeadingGroup, Content, Actions } = Dialog;

export type IncompatibleContractGroupModalProps = {
  open: boolean;
  onClose: () => void;
};

/**
 * Shown when the selected group has no roster under the selected contract — the two
 * choices from ContractSelectionStep and GroupAssignmentStep are incompatible.
 * Presentational only — closing returns to the invite flow with selections intact.
 */
const IncompatibleContractGroupModal = ({ open, onClose }: IncompatibleContractGroupModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} aria-describedby="incompatible-contract-group-modal-description">
      <HeadingGroup>{_t("You can't invite to this group")}</HeadingGroup>
      <Content>
        <Typography2 component="p" variant="bodyPrimary" id="incompatible-contract-group-modal-description">
          {_t(
            "This group isn't set up under the contract you chose. Go back and choose a different group or contract."
          )}
        </Typography2>
      </Content>
      <Actions>
        <Button variant="primary" onClick={onClose} data-testid="incompatible-contract-group-modal-close">
          {_t('Close')}
        </Button>
      </Actions>
    </Dialog>
  );
};

export default IncompatibleContractGroupModal;
